import React from "react";
import { Link } from "react-router-dom";
import { Link as Link1 } from 'react-scroll';
import logoLight from "../../assets/images/logo-sin-texto.png"

import {FiShoppingCart,FiDribbble,AiOutlineBehance,AiFillLinkedin,FaFacebookF,AiOutlineInstagram, AiOutlineTwitter,FiFileText,FiMail} from "../../assets/icons/vander"

export default function SmallFooter(){
    return(
        <>
        <footer className="bg-footer footer-bar">
            <div className="footer-py-30">
                <div className="container text-center">
                    <div className="row align-items-center">
                        <div className="col-sm-3">
                            <div className="text-sm-start">
                                <Link1 className="logo" to="home">
                                    <img src={logoLight} className="logo-dark-mode" alt="" style={{width:'70px'}}/>
                                </Link1>
                            </div>
                        </div>
                        <div className="col-sm-5 mt-4 mt-sm-0 pt-2 pt-sm-0">
                            <a href="/aviso-legal" className="text-secondary" target="_blank">Aviso legal</a>
                            <a href="/politica-privacidad" className="text-secondary" target="_blank" style={{marginLeft:'1rem'}}>Política de privacidad</a>
                        </div>
                        <div className="col-sm-4 mt-4 mt-sm-0 pt-2 pt-sm-0">
                            <ul className="list-unstyled social-icon foot-social-icon text-sm-end mb-0">
                                <li className="list-inline-item ms-1"><Link to="https://www.instagram.com/pilates_rizzo/" target="_blank" className="rounded"><AiOutlineInstagram/></Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        </>
    )
}